import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

// 获取列表
export const getBranchList = data => {
  return axios.request({
    url: "/finance/hq/bill/index",
    method: "post",
    data
  });
};
// 获取详情
export const getDetails = params => {
  return axios.request({
    url: `/finance/branch/bill/read/${params.id}`,
    method: "post",
    params
  });
};

// 删除数据
export const delBill = id => {
  return axios.request({
    url: `/finance/hq/bill/del/${id}`,
    method: "delete"
  });
};
// 更新数据
export const updateBill = data => {
  return axios.request({
    url: `/finance/hq/bill/update/${data.id}`,
    method: "post",
    data
  });
};

// 确认账单
export const confirmBill = id => {
  return axios.request({
    url: `/finance/hq/bill/confirm/${id}`,
    method: "post"
  });
};

// 核销账单
export const auditBill = data => {
  return axios.request({
    url: `/finance/hq/bill/audit/${data.id}`,
    method: "post",
    data
  });
};

// 重新计算
export const resetAmount = id => {
  return axios.request({
    url: `/finance/hq/bill/recalculate/${id}`,
    method: "post"
  });
};
// 导出明细
export const exportDetails = id => {
  return axios.request({
    url: `/finance/branch/bill/exportDetail/${id}`,
    method: "post"
  });
};

// 明细挂起
export const hangDetails = data => {
  return axios.request({
    url: `/finance/branch/bill/removeOut/${data.id}`,
    method: "post",
    data
  });
};

// 删除明细
export const deleteDetails = data => {
  return axios.request({
    url: `/finance/hq/bill/delete/${data.id}`,
    method: "post",
    data
  });
};
// 追加订单
export const appendCnbNo = data => {
  return axios.request({
    url: `/finance/hq/bill/append/${data.id}`,
    method: "post",
    data
  });
};

// 同步
export const sync = data => {
  return axios.request({
    url: `/finance/hq/bill/sync`,
    method: "get",
    data
  });
}

export const hangBill = data => {
  return axios.request({
    url: `/finance/hq/bill/setException/` + data.id,
    method: "post",
    data
  });
}

export const deleteBillDetails = data => {
  return axios.request({
    url: `/finance/hq/bill/removeDetail/` + data.id,
    method: "post",
    data
  });
}

export const outAnalyze = data => {
  return axios.request({
    url: `/finance/hq/bill/outAnalyze`,
    method: "post",
    data
  });
}
export const batchCancelConfirm = data => {
  return axios.request({
    url: `/finance/hq/dbl/bill/batchCancelConfirm`,
    method: "post",
    data
  });
}

export const adjust = data => {
  return axios.request({
    url: `/finance/statement/adjust/writeOff`,
    method: "post",
    data
  });
}

export const getWaitOffData = data => {
  return axios.request({
    url: `/finance/statement/adjust/getWaitOffData`,
    method: "post",
    data
  });
}

export function upload(data) {
  return axios.request({
    url: `/finance/statement/adjust/upload`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
}